<template>
  <div class="tab-bar">
    <!-- <img :src="png"> -->
    <div class="tab-bar-border"></div>
    <div
      v-for="(item, index) in tabbar.tabBarCustoms"
      :key="index"
      class="tab-bar-item">
      <div class="tab-bar-item-icon">
        <img
          v-if="item.checkedImage[0]"
          :src="item.checkedImage[0].url" />
        <img
          v-else
          :src="png1" />
      </div>
      <div :style="{color: tabbar.tabBarNameCheckedColour || '#999999'}">{{ item.tabBarName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeFooterView',
  props: {
    tabbar: {
      type: Object,
      default() {
        return {
          tabBarNameCheckedColour: null,
          tabBarNameUncheckedColour: null,
          tabBarCustoms: [
            {
              tabBarId: 1,
              tabBarName: '首页',
              checkedImage: [],
              uncheckedImage: []
            },
            {
              tabBarId: 2,
              tabBarName: '商城',
              checkedImage: [],
              uncheckedImage: []
            },
            {
              tabBarId: 3,
              tabBarName: '购物车',
              checkedImage: [],
              uncheckedImage: []
            },
            {
              tabBarId: 4,
              tabBarName: '我的',
              checkedImage: [],
              uncheckedImage: []
            }
          ],
          visible: false
        }
      }
    }
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      png1: require('../image/tabbar/1-1.png')
    }
  },
  computed: {

  }
}
</script>
<style lang="stylus" scoped>
.tab-bar {
  position: relative;
  height: 48px;
  background: white;
  display: flex;
  padding-bottom: env(safe-area-inset-bottom);
}

.tab-bar-border {
  background-color: rgba(0, 0, 0, 0.33);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  transform: scaleY(0.5);
}

.tab-bar-item {
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.tab-bar-item-icon {
  position: relative;
  overflow: visible !important;
}

.tab-bar-item img {
  width: 27px;
  height: 27px;
}

.tab-bar-item div {
  font-size: 10px;
}

.van-info {
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
  min-width: 16px;
  padding: 0 3px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
  line-height: 14px;
  text-align: center;
  background-color: #ee0a24;
  border: 1px solid #fff;
  border-radius: 16px;
  transform: translate(50%, 0);
  transform-origin: 100%;
}

.van-info--dot {
  width: 8px;
  min-width: 0;
  height: 8px;
  background-color: #ee0a24;
  border-radius: 100%;
}
</style>
